import { render, staticRenderFns } from "./PredefinedAnswerItem.vue?vue&type=template&id=3c61575a&"
import script from "./PredefinedAnswerItem.vue?vue&type=script&lang=js&"
export * from "./PredefinedAnswerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports